import _typeof from "@babel/runtime/helpers/typeof";
function isInArray(arr) {
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function isInArrayFn(props, propName, componentName) {
    var prop = props[propName];
    var isValid = arr.includes(prop);
    if (!isValid && isRequired) {
      return new Error("'".concat(prop, "' is not a valid value for the prop '").concat(propName, "' at '").concat(componentName, "' component"));
    }
    return null;
  };
}
var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};
var isObject = function isObject(object) {
  return !isUndefined(object) && object != null && _typeof(object) === 'object';
};
export var isEmpty = function isEmpty(object) {
  return isObject(object) && ((object === null || object === void 0 ? void 0 : object.constructor) === Object || (object === null || object === void 0 ? void 0 : object.constructor) === Array) && Object.keys(object).length === 0 || !object;
};
export default {
  isInArray: isInArray
};